import { SkeletonCard, SkeletonListRow, SkeletonStatChip } from '../common';

const ROWS_COUNT = 13;
const STATS_COUNT = 5;

const RIGHT_BLOCK = (
  <div className="flex items-center gap-[8px] shrink-0">
    {Array.from({ length: STATS_COUNT }).map((_, j) => (
      <SkeletonStatChip key={j} />
    ))}
  </div>
);

export function TableRowsBlock() {
  return (
    <SkeletonCard className="h-[462px] gap-[4px]">
      {Array.from({ length: ROWS_COUNT }).map((_, i) => (
        <SkeletonListRow key={i} rightBlock={RIGHT_BLOCK} />
      ))}
    </SkeletonCard>
  );
}
